import { render } from "./CategoryTemplate.vue?vue&type=template&id=a902d0aa&scoped=true"
import script from "./CategoryTemplate.vue?vue&type=script&lang=js"
export * from "./CategoryTemplate.vue?vue&type=script&lang=js"

import "./CategoryTemplate.vue?vue&type=style&index=0&id=a902d0aa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a902d0aa"]])

export default __exports__